/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2026 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { AVAILABLE_FREE_GIFTS_FRAGMENT } from '@/cart/api/graphql/AvailableFreeGiftsFragment';

export const GUEST_AVAILABLE_FREE_GIFTS_QUERY = `
  query GUEST_AVAILABLE_FREE_GIFTS_QUERY($cartId: String!) {
    cart(cart_id: $cartId) {
      ...AVAILABLE_FREE_GIFTS_FRAGMENT
    }
  }

  ${AVAILABLE_FREE_GIFTS_FRAGMENT}
`;

export const CUSTOMER_AVAILABLE_FREE_GIFTS_QUERY = `
  query CUSTOMER_AVAILABLE_FREE_GIFTS_QUERY {
    cart: customerCart {
      ...AVAILABLE_FREE_GIFTS_FRAGMENT
    }
  }

  ${AVAILABLE_FREE_GIFTS_FRAGMENT}
`;
